import { memo } from "react";
import { HistoryDetailsBaseRow } from "./historyDetailsBaseRow";
import { RelativeDateCell } from "./RelativeDateCell";

export const LogTimeCell = memo(
    ({ row }: { row: { original: HistoryDetailsBaseRow } }) => (
        <RelativeDateCell row={row} dateField="logDate" />
    ),
);

LogTimeCell.displayName = "LogTimeCell";
